// Desktop: a side video swaps places with the lead one. Phones play in place.
const desktop = window.matchMedia('(min-width: 641px)');
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
const EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
const DURATION = 520;

// Slides and scales an element from its old box to where it sits now.
function flip(el: HTMLElement, from: DOMRect): Animation {
	const to = el.getBoundingClientRect();

	return el.animate(
		[
			{
				transformOrigin: 'top left',
				transform: `translate(${from.left - to.left}px, ${from.top - to.top}px) scale(${from.width / to.width}, ${from.height / to.height})`,
			},
			{ transformOrigin: 'top left', transform: 'none' },
		],
		{ duration: DURATION, easing: EASE }
	);
}

function bind(list: HTMLElement): void {
	// A played video goes back to its thumbnail when it leaves the lead spot.
	const idle = new Map<HTMLElement, Node[]>();

	list.querySelectorAll<HTMLElement>('[data-armada-video]').forEach((player) => {
		idle.set(player, Array.from(player.childNodes));
	});

	let busy = false;

	list.addEventListener(
		'click',
		(event) => {
			const item = (event.target as HTMLElement).closest<HTMLElement>('.armada-videos__item');
			const lead = list.querySelector<HTMLElement>('.armada-videos__item.is-lead');

			if (!desktop.matches || !item || !lead || item === lead) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			if (busy) {
				return;
			}

			const leadPlayer = lead.querySelector<HTMLElement>('[data-armada-video]');
			const itemPlayer = item.querySelector<HTMLElement>('[data-armada-video]');

			if (!leadPlayer || !itemPlayer) {
				return;
			}

			const leadFrom = leadPlayer.getBoundingClientRect();
			const itemFrom = itemPlayer.getBoundingClientRect();

			if (leadPlayer.querySelector('iframe')) {
				leadPlayer.replaceChildren(...(idle.get(leadPlayer) || []));
			}

			// Trade places in the DOM so tab order follows the layout.
			const marker = document.createComment('');
			item.replaceWith(marker);
			lead.replaceWith(item);
			marker.replaceWith(lead);
			lead.classList.remove('is-lead');
			item.classList.add('is-lead');

			if (reduced.matches) {
				return;
			}

			busy = true;
			item.classList.add('is-arriving');
			itemPlayer.style.zIndex = '1';

			const moves = [flip(itemPlayer, itemFrom), flip(leadPlayer, leadFrom)];

			Promise.all(moves.map((move) => move.finished)).finally(() => {
				busy = false;
				itemPlayer.style.zIndex = '';
				item.classList.remove('is-arriving');
			});
		},
		true
	);
}

export default function initVideos(): void {
	document.querySelectorAll<HTMLElement>('[data-armada-videos]').forEach(bind);
}
